function CockpitSingleSignal() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Cockpit.Overview.SingleSignal visual. <br/>
    /// 
    /// <br/>
    /// Author: ARF<br />
    /// Date: 9.11.2018<br />
    /// Copyright ©: EUDT GmbH 2018 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 5.12.2018                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    // the following attributes got set in Charts.Cockpit.Cockpit1.vb
    this.day = "";
    this.dateRange = null;
    this.bInit = false;
    this.chartCounter = 0;
    this.wC1 = 0;
    this.wC2 = 0;
    this.wC3 = 0;
    this.hC1Daily = 0;
    this.hC1Monthly = 0;
    this.hC1Yearly = 0;
    this.hC2 = 0;
    this.hC3 = 0;
}

CockpitSingleSignal.prototype = new vcTemplate();

CockpitSingleSignal.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
   
    try {
        if (me.error) { return false; }

        me.showInfo("", "", false);
        
        me.visual.find(".left").height(me.height - 70);
       
        me.visual.find(".c3").css("margin-top", ((me.height/310) * 3.7) + "em" );

        if (me.showDetails) {
          
            me.visual.find(".right").height(me.height - 57);
            me.visual.find(".chart").height(me.height - 160);
            me.visual.find(".c1").height(me.height - 73);
            me.visual.find(".c2").height(me.height - 28);
        }
        else {
            me.visual.find(".right").height(me.height - 80);
            me.visual.find(".c2").height(me.height - 48);
        }
       

        //we need the widths and heights of the charts before we start to hide/show them
        me.wC2 = parseInt(me.visual.find('.c2').width(), 10);
        me.hC2 = parseInt(me.visual.find('.c2').height(), 10);
        me.wC3 = parseInt(me.visual.find('.c3').width(), 10);
        me.hC3 = parseInt(me.visual.find('.c3').height(), 10);
        me.wC1 = parseInt(me.visual.find('.c1').width(), 10);

        me.visual.find(".c1").addClass("daily");
        me.hC1Daily = parseInt(me.visual.find('.c1').height(), 10);

        me.visual.find(".c1").removeClass("daily").addClass("monthly");
        me.hC1Monthly = parseInt(me.visual.find('.c1').height(), 10);

        me.visual.find(".c1").removeClass("monthly").addClass("yearly");
        me.hC1Yearly = parseInt(me.visual.find('.c1').height()-16, 10);


      

        //detail button event handler
        me.visual.find(".details").off("click").on("click", function () { _VCMQ.produce(me.visual, me.vcgid, 'TOGGLE_DETAILS', {  'day':me.day, 'obj': $(this) }); });

        if (me.showDetails) {
            
            me.loadCharts();
        } else {
            //if we are a visual in the subsignal list we first get the current dates from the cockpit
            _VCMQ.produce(me.visual, me.vcgid, 'GET_DATE', "");
        }

        return true;
    } catch (ex) { me.writeError('init', ex); return false }

}

CockpitSingleSignal.prototype.loadCharts = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    var  c3Name="";
    var series;
    var comparisonDate;
    me.chartCounter = 0;

    var param;
    var signalParam = { 'series': [] };
    var containerC1, containerC2, containerC3;
    try {
        if (me.error) { return false; }

        me.chartCounter = 0;
        
        if ((me.visual.is(":visible") === false) && (me.showDetails)) {return true;}
       
        me.visual.find('.chart').hide();
        me.visual.find('.c1').html(me.vcC.getLoadingIcon());

        containerC1 = me.getRandomIDContainerObj("div-chart-", false);
        me.visual.find("#div" + me.bsaid + 'c1').html(containerC1.obj);
        containerC2 = me.getRandomIDContainerObj("div-chart2-", false);
        me.visual.find("#div" + me.bsaid + 'c2').html(containerC2.obj);

        containerC3 = me.getRandomIDContainerObj("div-chart3-", false);
        me.visual.find("#div" + me.bsaid + 'c3').html(containerC3.obj);

        param = { 'loggerID': me.blid, 'UsePrices':me.usePrices, 'FixTooltip': true, 'HideLegend': true, 'GetSingleValuesAsConsumption': true,'NoZoom':false, 'ShowInvalidValues': true, 'ShowPlotLines': true, 'ShowIntervention': false, 'ShowEmptyChart': true, 'ShowExportIcons': false }
        series = { 'bsaid': [me.bsaid], 'rule': '[bsaid=' + me.bsaid + ']', 'ruleType': 1 };
        signalParam.series.push(series);

        param.MqEventOnPointClick = true;

        switch (me.interval) {
            case 1:
              
                //main chart in the middle
                param.datatype = 1;
                param.startDate = me.day;
                param.endDate = me.day;
                signalParam.series[0].seriesType = "spline";
                me.vcVisual.addVisualBaseByName('div-chart2-', "VISUAL_RAMP_SINGLE", containerC2.random, me.day, me.hC2, me.wC2, JSON.stringify(param), JSON.stringify(signalParam), me.deviceType, function () {
                    me.fadeInCharts();
                });
                //left chart - no loading if we don't show details
                if (me.showDetails) {
                    param.datatype = 2;
                    param.startDate = moment(param.startDate, "DD.MM.YYYY").add(-6, "days").toDate("DD.MM.YYYY");
                    param.startDate = $.datepicker.formatDate('dd.mm.yy', param.startDate);
                    param.DateuserDef = true;
                    param.interval = 1;
                    signalParam.series[0].seriesType = "column";


                    me.vcVisual.addVisualBaseByName('div-chart-',"VISUAL_RAMP_DAILY",containerC1.random, me.day,me.hC1Daily,me.wC1,JSON.stringify(param), JSON.stringify(signalParam), me.deviceType,
                        function() {
                            me.fadeInCharts();
                        });
                }
                // right summary chart
                comparisonDate = me.day;
                c3Name = "VISUAL_SUMMARY_DAILY";
                break;
            case 3:

               
                //main chart in the middle
                param.datatype = 2;
                signalParam.series[0].seriesType = "column";
                param.startDate = me.dateRange.from;
                param.endDate = me.dateRange.to;
                param.DateuserDef = false;
                param.interval = 1;

                me.vcVisual.addVisualBaseByName('div-chart2-', "VISUAL_RAMP_DAILY", containerC2.random, me.day, me.hC2, me.wC2, JSON.stringify(param), JSON.stringify(signalParam), me.deviceType, function () {
                   
                    me.fadeInCharts();
                });

                //left chart - no loading if we don't show details
                if (me.showDetails) {
                    param.startDate = moment(param.startDate, "DD.MM.YYYY").add(-5, "months").toDate("DD.MM.YYYY");
                    param.startDate = $.datepicker.formatDate('dd.mm.yy', param.startDate);
                    param.DateuserDef = true;
                    param.interval = 3;
                   
                    containerC1.obj.addClass("year");
                    me.vcVisual.addVisualBaseByName('div-chart-', "VISUAL_RAMP_MONTHLY",containerC1.random,me.day,me.hC1Monthly, me.wC1,JSON.stringify(param),JSON.stringify(signalParam), me.deviceType,
                        function() {
                            me.fadeInCharts();
                        });
                }

                // right summary chart
                comparisonDate = me.dateRange.from;
                comparisonDate = moment(comparisonDate, "DD.MM.YYYY")
                    .add(moment(me.currentDate, "DD.MM.YYYY").date() - 1, "days");
                c3Name = "VISUAL_SUMMARY_MONTHLY";
                break;
            case 5:
             

                param.datatype = 2;
                signalParam.series[0].seriesType = "column";
                param.startDate = me.dateRange.from;
                param.endDate = me.dateRange.to;
                param.DateuserDef = false;
                param.interval = 5;

                me.vcVisual.addVisualBaseByName('div-chart2-', "VISUAL_RAMP_MONTHLY", containerC2.random, me.day, me.hC2, me.wC2, JSON.stringify(param), JSON.stringify(signalParam), me.deviceType, function () {
                    me.fadeInCharts();
                });

                if (me.showDetails) {
                    param.startDate = moment(param.startDate, "DD.MM.YYYY").add(-2, "years").toDate("DD.MM.YYYY");
                    param.startDate = $.datepicker.formatDate('dd.mm.yy', param.startDate);
                    param.DateuserDef = true;
                    param.interval = 3;

                    me.vcVisual.addVisualBaseByName('div-chart-',"VISUAL_RAMP_YEARLY",containerC1.random,me.day, me.hC1Yearly,me.wC1,JSON.stringify(param),JSON.stringify(signalParam),me.deviceType,
                        function() {
                            me.fadeInCharts();
                        });
                }

                // right summary chart
                comparisonDate = me.dateRange.from;
                comparisonDate = moment(comparisonDate, "DD.MM.YYYY")
                    .add(moment(me.currentDate, "DD.MM.YYYY").date() - 1, "days");
                comparisonDate = moment(comparisonDate, "DD.MM.YYYY")
                   .add(moment(me.currentDate, "DD.MM.YYYY").month(), "months");
                c3Name = "VISUAL_SUMMARY_YEARLY";
                break;
        default:
        }
        
        //show the right summary chart
        me.vcVisual.addVisualBaseByName("div-chart3-", c3Name, containerC3.random, moment(comparisonDate, "DD.MM.YYYY").toDate(), me.hC3, me.wC3, "",
            JSON.stringify({ "loggerid": me.blid, "signalid": me.bsaid, "UsePrices": me.usePrices }),
            me.deviceType,
            function() {
               
                me.fadeInCharts();
            });
        
        return true;
    } catch (ex) {
me.writeError('loadCharts', ex); return false }

}

CockpitSingleSignal.prototype.fadeInCharts = function () {
    /// <summary>
    /// This function counts all loaded charts and shows all of them at once
    /// </summary>
    var me = this;
    var max = 3;
    try {

        if (me.showDetails === false) { max --;}
            me.chartCounter++;
            if (me.chartCounter === max) {
                me.visual.find('.chart').show();
                me.bInit = true;
            } 

    } catch (ex) { writeError('fadeInCharts', ex); }
};

CockpitSingleSignal.prototype.doEvent = function (event) {
    /// <summary>
    /// Not needed here right now ...
    /// </summary>
    var me = this;
    try {
        if (event !== null) {

            switch (event.msg) {
                case 'CHANGE_DATE':
                    
                    if (event.values.vcgid === -1 || event.values.vcgid === me.vcgid) {
                        me.usePrices = event.values.usePrices;
                        me.interval = event.values.interval;
                        if (me.interval === 1) {
                            me.day = event.values.dates.singleDate;
                        } else {
                            me.dateRange = event.values.dates.returnDates;
                        }
                        me.loadCharts();
                    }
                    break;
                default:
                break;
            }
        }
    } catch (ex) { writeError('doEvent', ex); }
};

CockpitSingleSignal.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};



